import React, { useState, useEffect } from "react";
import { Input, Modal, Form, Button, Select } from "antd";
import { noop, isEmpty } from "lodash";

const { Option } = Select;

const CatalogLabFormModal = ({
  data = {},
  columnData,
  visible,
  submitText,
  title,
  onCancel,
  ...props
}) => {
  const [form] = Form.useForm();

  const onOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        await props.onSubmit(values);
        onCancel();
        form.resetFields();
        columnData = "";
        if (isEmpty(data)) {
          form.resetFields();
        }
      })
      .catch(noop);
  };
  const onModalCancel = () => {
    form.resetFields();
    columnData = "";
    onCancel();
  };
  const modalFooter = (
    <Button onClick={onOk} type="primary">
      {submitText}
    </Button>
  );

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  return (
    <Modal
      visible={visible}
      onCancel={onModalCancel}
      onOk={onOk}
      title={title}
      okText={submitText}
      destroyOnClose
      footer={modalFooter}
      {...props}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={onOk}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Please input Name!" },
            { max: 25, message: "Name must be maximum 25 characters." },
          ]}
        >
          <Input size="large" placeholder="Enter Name" />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select Status!" }]}
        >
          <Select name="status" size="large" placeholder="Status">
            <Option value={true}>Active</Option>
            <Option value={false}>Blocked</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CatalogLabFormModal;
